import * as React from "react";

function SvgSquareSimple(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}><path d="M21.1 6.8v36.4H0V22.1L21.1 6.8zm28.9 0v36.4H28.9V22.1L50 6.8z" /></svg>;
}

export default SvgSquareSimple;